import {Component, EventEmitter} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {TwoFactorFormModel, TwoFactorType} from '../../../../projects/api/src/authentication/twofactor.model';
import {AuthService} from '../../shared/services/auth.service';
import {ActivatedRoute} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {InsparkMessageService} from '@inspark/inspark-components';
import {AsyncPipe, NgClass} from '@angular/common';
import {LogoAtommindComponent} from '../../shared/components/logo-atommind/logo-atommind.component';
import {LoginTextInputComponent} from '../../shared/forms/fields/login-text-input/login-text-input.component';


@Component({
  selector: 'sem-twofactor-form',
  templateUrl: './twofactor-form.component.html',
  standalone: true,
  imports: [
    NgClass,
    TranslateModule,
    LogoAtommindComponent,
    ReactiveFormsModule,
    AsyncPipe,
    LoginTextInputComponent
  ],
  styleUrls: ['./twofactor-form.component.scss']
})
export class TwofactorFormComponent {
  public loginForm: FormGroup;
  public loginMessage = 'Insert code';
  public errorMessage = new EventEmitter<boolean>();
  isFoucs = true;
  public account?: string;
  private twoFactorType: TwoFactorType | null = null;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService,
    private translateService: TranslateService,
    private messageService: InsparkMessageService,
  ) {
    this.createForm();
    this.twoFactorType = this.route.snapshot.queryParams.type as TwoFactorType;
    this.account = this.route.snapshot.queryParams.account;

    if ((this.twoFactorType + '').toLowerCase() === 'totp') {
      this.loginMessage = this.translateService.instant('Insert totp code');
    } else {
      this.loginMessage = this.translateService.instant('Code send to');
    }
  }

  createForm() {
    const form: TwoFactorFormModel = {
      code: ''
    };
    this.loginForm = this.fb.group(form as { [p: string]: any });
  }

  onSubmit() {
    const request = this.loginForm.value as TwoFactorFormModel;

    if (this.twoFactorType) {
      this.authService.loginBy2FA(this.twoFactorType, request.code).subscribe(user =>
          this.authService.completeLogin(user),
        data => {
          this.messageService.error(this.translateService.instant(data.error?.Message || 'Произошла неизвестная ошибка'));
        }
      );
    }
  }
}
